import { useState, useRef} from "react";
import { useSearchParams } from 'react-router-dom';
import { FluentProvider } from "@fluentui/react-components";
import { duploLightTheme, Label, TextStyle, FontColor } from "@lannister/duplo";

import LoadingView from "../loadingView";
import PaymentMethods from "../Checkout/paymentMethods";
import usePaymentLink from "./usePaymentLink";
import { PaymentMethodType } from "../../common/constans";
import UTILS from "../../common/utils";
import InvoiceDetails from "./invoiceDetails";
import RequiredDetails from "./requiredDetails";
import "./styles.css";
import useApplePay from "../../hooks/apple-pay";

const PaymentLinkView = () => {
    const selectedPaymentMethodRef = useRef(PaymentMethodType.BankCard);
    const [isPaymentDataValid, setIsPaymentDataValid] = useState(false);
    const [isRequiredFieldsFilled, setIsRequiredFieldsFilled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const paymentDataRef = useRef({});
    const customerDataRef = useRef({});
    const isApplePayAvailable = useApplePay();

    const getProfileName = () => {
        let paths = window.location.pathname.split("/");
        let profileName = paths.pop();
        while (profileName === '') {
            profileName = paths.pop();
        }

        return profileName;
    }

    const getMerchantName = () => {
        return profileName.split('_')[0];
    }

    const getMerchantId = () => {
        return profileName.split('_')[1];
    }

    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const orderRef = searchParams.get('order');
    const profileName = getProfileName();
    const merchantId = getMerchantId();

    const {
        isLoading,
        sessionInfo,
        error,
        merchantLogo,
        isPaying,
        paymentLinkDetails,
        submitPayment } = usePaymentLink(sessionId, profileName, orderRef, merchantId);

    const onSubmit = () => {
        setSubmitted(true);
        console.log(isRequiredFieldsFilled); // will be used later
        submitPayment(paymentDataRef.current, selectedPaymentMethodRef.current);
    }

    const handlePaymentDataChange = (field, value) => {
        paymentDataRef.current[field] = value;
        setIsPaymentDataValid(UTILS.ValidateFormData(paymentDataRef.current, selectedPaymentMethodRef.current));
    };

    const handleCustomerDataChange = (field, value) => {
        customerDataRef.current[field] = value;
    }

    const onChangeSelectedPaymentMethod = (method) => {
        selectedPaymentMethodRef.current = method;
        paymentDataRef.current = {};
       setIsPaymentDataValid(UTILS.ValidateFormData(paymentDataRef.current, selectedPaymentMethodRef.current));
    };

    if (isLoading) return (<LoadingView color='#4055FF'/>);
    if (error) return (<Label labelText={error} textStyle={TextStyle.Heading5Regular} textColor={FontColor.Error} />);

    return (
        
        <FluentProvider theme={duploLightTheme}>
            { error && <Label labelText={error} textStyle={TextStyle.Heading5Regular} textColor={FontColor.Error} /> }
            <div className="page-container">
                <div className="left-panel">
                    <div className="invoice-header">
                        { merchantLogo !== null && <img src={merchantLogo} className="merchant-logo" alt="merchant" /> }
                        <div className="merchant-text">
                            <Label labelText={getMerchantName()} textStyle={TextStyle.Heading5Regular} />
                            <Label
                                labelText={`${sessionInfo.amount} ${sessionInfo.currency}`}
                                textStyle={TextStyle.Heading3Semibold} />
                        </div>
                    </div>

                    {paymentLinkDetails.merchant_checkout_form_schema !== null &&
                        <RequiredDetails
                            onDataChange={handleCustomerDataChange}
                            schema={paymentLinkDetails.merchant_checkout_form_schema.schema}
                            setIsValid={setIsRequiredFieldsFilled}
                            submitted={submitted} />}

                    <InvoiceDetails
                        invoiceId={paymentLinkDetails.merchant_reference}
                        expirationDate={paymentLinkDetails.expires_at}
                        extraDetails={paymentLinkDetails.extra_custom_details} />
                </div>

                <div className="right-panel">
                    <PaymentMethods
                        isCardEnabled={sessionInfo.is_bank_card_enabled}
                        isWalletEnabled={sessionInfo.is_wallet_enabled}
                        isApplePayEnabled={sessionInfo.is_apple_pay_enabled && isApplePayAvailable}
                        handleChange={handlePaymentDataChange}
                        onSubmit={onSubmit}
                        isLoading={isPaying}
                        onChangeSelectedPaymentMethod={onChangeSelectedPaymentMethod}
                        isFormValid={isPaymentDataValid}
                        amount={sessionInfo.amount}
                        currency={sessionInfo.currency}
                        shouldShowAmount={sessionInfo.should_show_amount}
                        isSaveCardOptionEnabled={sessionInfo.is_save_card_checkbox_enabled} />
                </div>
            </div>
        </FluentProvider>
    );
}

export default PaymentLinkView;
